import React from 'react';
import { Form, Row, Col, Button, Card, Container } from 'react-bootstrap';
import { ServiceFilterCriteria } from '../../interfaces';
import { useTranslation } from 'react-i18next';
import './../Devices/DeviceScanControl.css';

interface FilterComponentProps {
  onFilterChange: (criteria: ServiceFilterCriteria) => void;
  refetch: () => void;
  onlyInProd?: boolean;
}

const FilterComponent: React.FC<FilterComponentProps> = ({ onFilterChange }) => {
  const { t } = useTranslation();
  const [filterCriteria, setFilterCriteria] = React.useState<ServiceFilterCriteria>({ name: '', version: '' });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilterCriteria(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onFilterChange(filterCriteria);
  };

  return (
    <Container>
      <Card className="shadow mt-2">
        <Card.Header className="bg-primary text-white clickable">
          <Card.Title className="fs-2 text-center">{t("services.title.servicesFilter")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Row className="align-items-end">
              <Col md={3} className="ms-0">
                <Form.Group controlId="formName">
                  <Form.Label className="fs-5 fw-semibold text-secondary">{t('name')}</Form.Label>
                  <Form.Control type="text" name="name" value={filterCriteria.name} onChange={handleChange} placeholder={t("tools.enterName")} className='text-secondary bg-light fw-medium' />
                </Form.Group>
              </Col>
              <Col md={3} className="ms-0">
                <Form.Group controlId="formName">
                  <Form.Label className="fs-5 fw-semibold text-secondary">{t('version')}</Form.Label>
                  <Form.Control type="text" name="version" value={filterCriteria.version} onChange={handleChange} placeholder={t("enterVersion")} className='text-secondary bg-light fw-medium' />
                </Form.Group>
              </Col>
              <Col md={3} className="ms-0">
                <Form.Group controlId="formExternalPort">
                  <Form.Label className="fs-5 fw-semibold text-secondary">{t('services.header.externalPort')}</Form.Label>
                  <Form.Control type="number" name="defaultExternalPort" value={filterCriteria.defaultExternalPort || ''} onChange={handleChange} placeholder={t("devices.services.enterDefaultExternalPort")} className='text-secondary bg-light fw-medium' />
                </Form.Group>
              </Col>
              <Col md={3} className="d-flex align-items-center justify-content-end gap-4">
                <Form.Group controlId="formInProd">
                  <Form.Check
                    type="switch"
                    id='prod-switch'
                    label={t("inProduction")}
                    checked={filterCriteria.onlyInProd || false}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setFilterCriteria(prev => ({ ...prev, onlyInProd: isChecked }));
                      onFilterChange({ ...filterCriteria, onlyInProd: isChecked });
                    }}
                    className='text-secondary fw-semibold'
                  />
                </Form.Group>
                <Button variant="secondary" type="submit" className="py-1 px-3 fs-5">{t("apply")}</Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default FilterComponent;
